// Light / dark theme. The choice is kept per browser; the default is light.
const KEY = 'mm-theme';

export function getTheme() {
  try { return window.localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'; } catch (e) { return 'light'; }
}

export function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme === 'dark' ? '#0A1120' : '#0D1626');
}

export function setTheme(theme) {
  try { window.localStorage.setItem(KEY, theme); } catch (e) { /* private mode: still switch for this visit */ }
  applyTheme(theme);
}
